<template>
    <NarrowContent
        :hasSpacings="false">
        <div class="main">
            <SideBar
                :selectedTab="selectedTab"
                :isMobile="isMobile"
                :content="content"
                @changeSelectedTab="changeTab"/>
            
            <Button class="backButton"
                v-if="isMobile && selectedTab !== ''"
                appearance="secondary"
                prefixIcon="arrow_left"
                @click="selectedTab = ''">
                {{ content.back }}
            </Button>

            <section class="mainContent">
                <div class="headWrapper"
                    v-if="selectedTab !== ''">
                    <Heading
                        :h="2"
                        size="l">
                        {{ tabTitle }}
                    </Heading>
                    <p class="disclaimer">
                        {{ siteContent.changesApplyInstantly }}
                    </p>
                </div>

                <Language
                    v-if="selectedTab === 'language'"
                    :content="content"/>
                <Timeline
                    v-else-if="selectedTab === 'timeline'"
                    :content="content"/>
                <Display
                    v-else-if="selectedTab === 'display'"
                    :content="content"/>
                <Privacy
                    v-else-if="selectedTab === 'privacy'"
                    :content="content"/>
                <WaitlistInvite
                    v-else-if="selectedTab === 'waitlist'"
                    :content="content"/>
            </section>
        </div>
    </NarrowContent>
</template>

<script>
    import content       from '@/components/settings/settings.js'

    import NarrowContent  from '@/components/layout/NarrowContent'
    import SideBar        from '@/components/settings/SideBar'
    import Language       from '@/components/settings/Language'
    import Timeline       from '@/components/settings/Timeline'
    import Display        from '@/components/settings/Display'
    import Privacy        from '@/components/settings/Privacy'
    import WaitlistInvite from '@/components/settings/WaitlistInvite'

    export default {
        name: 'Settings',
        components: {
            NarrowContent,
            SideBar,
            Language,
            Timeline,
            Display,
            Privacy,
            WaitlistInvite
        },
        data() {
            return {
                selectedTab: 'language',
                tabTitle: '',
                isMobile: false
            }
        },
        computed: {
            content() {
                return this.getContent(content)
            }
        },
        methods: {
            changeTab(item, index) {
                this.tabTitle = item.tabTitle
                this.selectedTab = index
            },

            setMobile() {
                if (window.matchMedia("(max-width: 700px)").matches) {
                    this.selectedTab = ''
                    this.isMobile = true
                }
            },
        },
        mounted() {
            this.setMobile()
        },
        metaInfo() {
            if(this.preferences.language === 'hu') {
                return {
                    title: 'Beállítások | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Változtass nyelv, valuta, megjelenés, kezelőfelület és idővonal beállításaidon a Creatillo oldalon.' }
                    ]
                }
            } else {
                return {
                    title: 'Settings | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Modify your language, currency, display, interface and timeline preferences on Creatillo.' }
                    ]
                }
            }
        }
    }
</script>


<style scoped lang="scss">
    @import '../scss/variables';

    .main {
        display: flex;
        flex-grow: 1;
    }

    .h2 {
        margin: 0;
    }

    .disclaimer {
        color: var(--color-grey-500);
        font-size: 1rem;
        margin: 0.5rem 0 1.5rem 0;
    }

    .mainContent {
        display: flex;
        flex-direction: column;
        width: calc(100% - 20rem);
        min-height: 40rem;
        padding: 2rem 2rem 2rem 3rem;
    }

    .backButton {
        margin-top: 0.5rem;
    }

    @media all and (max-width: 1024px) {
        .mainContent {
            padding: 2rem 1rem 2rem 1.5rem;
            width: 100%;
        }
    }

    @media all and (max-width: 640px) {
        .main {
            flex-direction: column;
        }
    }

    @media all and (max-width: 880px) {
        .fruits {
            flex-direction: column;
        }
    }
</style>